import quest_item_1 from '../../assets/quest/quest_item_icon_1.webp';
import quest_item_2 from '../../assets/quest/quest_item_icon_2.webp';
import quest_item_3 from '../../assets/quest/quest_item_icon_3.webp';
import quest_item_4 from '../../assets/quest/quest_item_icon_4.webp';
import prize_icon from '../../assets/quest/trophy_icon.webp';
import {
	QuestItemContent,
	QuestItemDescription,
	QuestItemIcon,
	QuestItemProgress,
	QuestItemTitle,
	QuestItemWrapper,
	QuestItemBox
} from './Items';

export default function QuestItem({ scale }) {
	const QUEST_DATA = [
		{
			icon: quest_item_1,
			title: 'Catch 3x Alien Symbol',
			desc_1: 'Bet Relevant',
			desc_2: '90% Bet Discount',
			color: 'rgba(113, 178, 238, 1)',
			width: 4,
			progress: '1/25'
		},
		{
			icon: quest_item_4,
			title: 'Spin $5+ Bet Amount',
			desc_1: 'Bet Relevant',
			desc_2: '3x Wild Respin',
			color: 'rgba(183, 238, 113, 1)',
			width: 30,
			progress: '20/60'
		},
		{
			icon: quest_item_2,
			title: 'Catch Min. 2x Scatter',
			desc_1: 'Bet Relevant',
			desc_2: '50% Bonus Discount',
			color: 'rgba(183, 113, 238, 1)',
			width: 20,
			progress: '5/25'
		},
		{
			icon: quest_item_3,
			title: 'Catch +30x Multiplier',
			desc_1: 'Bet Relevant Free',
			desc_2: 'Bonus Game',
			color: 'rgba(238, 113, 173, 1)',
			width: 40,
			progress: '40/100'
		}
	];

	return (
		<QuestItemWrapper>
			{QUEST_DATA.map((item, id) => (
				<QuestItemBox scale={scale} key={id}>
					<QuestItemIcon>
						<img src={item.icon} alt='quest_item' />
					</QuestItemIcon>
					<QuestItemContent>
						<QuestItemTitle scale={scale} color={item.color}>
							{item.title}
						</QuestItemTitle>
						<QuestItemDescription scale={scale}>
							<img src={prize_icon} alt='prize' />
							{item.desc_1}
							<span className='blue'> {item.desc_2}</span>
						</QuestItemDescription>
						<QuestItemProgress scale={scale} width={item.width}>
							<div className='progress_inner'></div>
							<div className='progress_text'>{item.progress}</div>
						</QuestItemProgress>
					</QuestItemContent>
				</QuestItemBox>
			))}
		</QuestItemWrapper>
	);
}
